// /support — where the installed agent sends people from its Help menu and error pages. A short
// page in the Memory shell: how to reach us, and the door to the help doc. Nothing here needs auth.
import { Box, Typography } from "@mui/material";
import MemoryNav from "../components/MemoryNav";
import { HELP_URL } from "../utils/landing";

const link = { color: "#2da894", fontWeight: 600, textDecoration: "none" };

export default function Support() {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0b0b0f", color: "#fff", display: "flex", flexDirection: "column" }}>
      <MemoryNav />
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", px: 2, py: { xs: 4, md: 8 } }}>
        <Box sx={{ width: "100%", maxWidth: 560 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>Support</Typography>
          <Typography sx={{ opacity: 0.8, mb: 3 }}>
            We answer during business hours, usually the same day.
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            Questions, bugs, billing: <Box component="a" href="mailto:support@assertion-ai.com" sx={link}>support@assertion-ai.com</Box>
          </Typography>
          <Typography sx={{ mb: 1.5 }}>
            Report a security concern: <Box component="a" href="mailto:security@assertion-ai.com" sx={link}>security@assertion-ai.com</Box>
          </Typography>
          <Typography sx={{ mt: 3, opacity: 0.8 }}>
            Getting started, features and how the plugin and agent fit together are in the{" "}
            <Box component="a" href={HELP_URL} sx={link}>help guide</Box>.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
